import * as TimeSheetActionCreator from "./TimeSheetActionCreator";

export function timesheetByProjectId() {
  return {
    loading: false,
    response: null,
    error: null,
    page: 0,
    size: 10,
    employee: "",
    project: "",
    fromDate: "",
  };
}
export const TimeSheetByProjectIdReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      TimeSheetActionCreator.TIMESHEET_ACTION.RESET_TIMESHEET_BY_ID_STATE
  ) {
    return { ...state, ...timesheetByProjectId() };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_TIMESHEET_BY_ID
  ) {
    return {
      ...state,
      loading: true,
      page: action.data.page,
      size: action.data.size,
      employee: action.data.employee,
      project: action.data.project,
      fromDate: action.data.fromDate,
      employeeName: action.data.employeeName,
      projectName: action.data.projectName,
      sortby: action.data.sortby
    };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_TIMESHEET_BY_ID
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_TIMESHEET_BY_ID
  ) {
    return {
      ...state,
      error: action.data,
      loading: false,
      response: null,
      page: 0,
      size: 10,
    };
  }

  return state;
};

export function timesheetByProjectIdForUserPage() {
  return {
    loading: false,
    response: null,
    error: null,
    selectedProject: null,
    page: 0,
    size: 10,
    initialValues: {
      projectId: "",
      work_location: "",
      startDate: "",
      endDate: "",
      total_hours: null,
      holidays: null,
    },
  };
}
export const TimeSheetByProjectIdReducerForUserPage = (state, action) => {
  if (
    !state ||
    action.type ===
      TimeSheetActionCreator.TIMESHEET_ACTION
        .RESET_TIMESHEETS_BY_ID_FOR_USER_PAGE_STATE
  ) {
    return { ...state, ...timesheetByProjectIdForUserPage() };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION
      .REQUEST_TIMESHEETS_BY_ID_FOR_USER_PAGE
  ) {
    return {
      ...state,
      loading: true,
      page: action.data.page,
      size: action.data.size,
      selectedProject: action.data.project,
      initialValues: { ...state.initialValues, projectId: action.data.project},
    };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION
      .RESPONSE_TIMESHEETS_BY_ID_FOR_USER_PAGE
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_TIMESHEETS_BY_ID_FOR_USER_PAGE
  ) {
    return {
      ...state,
      error: action.data,
      loading: false,
      response: null,
      page: 0,
      size: 10,
    };
  }

  return state;
};

export function timesheetDetails() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}
export const AddTimesheetReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      TimeSheetActionCreator.TIMESHEET_ACTION.RESET_ADD_TIMESHEET_STATE
  ) {
    return { ...state, ...timesheetDetails() };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_ADD_TIMESHEET
  ) {
    return { ...state, loading: true };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_ADD_TIMESHEET
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type === TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_ADD_TIMESHEET
  ) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};

export function defaultEditTimesheetsState() {
  return {
    Loading: false,
    Response: null,
    Error: null,
  };
}
export const EditTimesheetsReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      TimeSheetActionCreator.TIMESHEET_ACTION.RESET_EDIT_TIMESHEETS
  ) {
    return { ...state, ...defaultEditTimesheetsState() };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_EDIT_TIMESHEETS
  ) {
    return { ...state, Loading: true };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_EDIT_TIMESHEETS
  ) {
    return { ...state, Response: action.data, Loading: false };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_EDIT_TIMESHEETS
  ) {
    return { ...state, Error: action.data, Loading: false };
  }

  return state;
};

export function defaultGetTimesheetById() {
  return {
    Loading: false,
    Response: null,
    Error: null,
    selectedProject: null,
  };
}
export const GetTimesheetByIdReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      TimeSheetActionCreator.TIMESHEET_ACTION.RESET_GET_TIMESHEET_BY_ID
  ) {
    return { ...state, ...defaultGetTimesheetById() };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_GET_TIMESHEET_BY_ID
  ) {
    return { ...state, Loading: true, selectedProject: action.data.project };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_GET_TIMESHEET_BY_ID
  ) {
    return { ...state, Response: action.data, Loading: false };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_GET_TIMESHEET_BY_ID
  ) {
    return { ...state, Error: action.data, Loading: false };
  }

  return state;
};

export function defaultTimesheetsAction() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}
export const TimesheetsActionReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      TimeSheetActionCreator.TIMESHEET_ACTION.RESET_TIMESHEETS_ACTION
  ) {
    return { ...state, ...defaultTimesheetsAction() };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_TIMESHEETS_ACTION
  ) {
    return { ...state, loading: true, response: null, error: null };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_TIMESHEETS_ACTION
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_TIMESHEETS_ACTION
  ) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};

export function defaultGenerateInvoice() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}
export const GenerateInvoiceReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      TimeSheetActionCreator.TIMESHEET_ACTION.RESET_GENERATE_INVOICE
  ) {
    return { ...state, ...defaultGenerateInvoice() };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_GENERATE_INVOICE
  ) {
    return { ...state, loading: true, response: null, error: null };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_GENERATE_INVOICE
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_GENERATE_INVOICE
  ) {
    return { ...state, error: action.data, loading: false, response: null };
  }

  return state;
};

export function downloadInvoiceState() {
  return {
    loading: false,
    response: null,
    error: null,
    action: null,
  };
}
export const DownloadInvoiceReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      TimeSheetActionCreator.TIMESHEET_ACTION.RESET_INVOICE_DOWNLOAD
  ) {
    return { ...state, ...downloadInvoiceState() };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_DOWNLOAD_INVOICE
  ) {
    return { ...state, loading: true };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_DOWNLOAD_INVOICE
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_DOWNLOAD_INVOICE
  ) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};

export function downloadTimeSheetState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}
export const DownloadTimeSheetReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      TimeSheetActionCreator.TIMESHEET_ACTION.RESET_DOWNLOAD_TIMESHEET
  ) {
    return { ...state, ...downloadTimeSheetState() };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_DOWNLOAD_TIMESHEET
  ) {
    return { ...state, loading: true };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_DOWNLOAD_TIMESHEET
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type ===
    TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_DOWNLOAD_TIMESHEET
  ) {
    return { ...state, error: action.data, loading: false };
  }

  return state;

};
export function defaultTimesheetListState() {
  return {
    loading: false,
    response: null,
    error: null,
    page:0,
    size:10,
    employeeName: ""
  };
}
  export const TimesheetListReducer = (state, action) => { 
    if (
      !state ||
      action.type === TimeSheetActionCreator.TIMESHEET_ACTION.RESET_TIMESHEET_LIST_STATE
    ) {
      return { ...state, ...defaultTimesheetListState() };
    }
  
    if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_TIMESHEET_LIST) {
      return { 
        ...state, 
        loading: true, 
        page: action.data.page, 
        size: action.data.size, 
        employeeName: action.data.employeeName || state?.employeeName || "",
        sortby: action.data.sortby || state?.sortby || null
      };
    }
  
    if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_TIMESHEET_LIST) {
      return { ...state, response: action.data, loading: false };
    }
  
    if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_TIMESHEET_LIST) {
      return { ...state, error: action.data, loading: false , response: null, page: 0, size: 10};
    }
  
    return state; 
  };

  export function defaultTimesheetAppState() {
    return {
      loading: false,
      response: null,
      error: null,
      page:0,
      size:10,
      search: "",
      sortby: null
    };
  }
    export const TimesheetAppReducer = (state, action) => { 
      if (
        !state ||
        action.type === TimeSheetActionCreator.TIMESHEET_ACTION.RESET_TIMESHEET_APP_STATE
      ) {
        return { ...state, ...defaultTimesheetAppState() };
      }
    
      if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_TIMESHEET_APP) {
        return { 
          ...state, 
          loading: true, 
          page: action.data.page, 
          size: action.data.size,
          search: action.data.search || state?.search || "",
          sortby: action.data.sortby || state?.sortby || null
        };
      }
    
      if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_TIMESHEET_APP) {
        return { ...state, response: action.data, loading: false };
      }
    
      if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_TIMESHEET_APP) {
        return { ...state, error: action.data, loading: false , response: null, page: 0, size: 10};
      }
    
      return state; 
    };
  
  
    export function defaultRejectedTimesheetsListState() {
      return {
        loading: false,
        response: null,
        error: null,
        page:0,
        size:10,
        employeeName: "",
        sortby: null
      };
    }
      export const RejectedTimesheetsListReducer = (state, action) => { 
        if (
          !state ||
          action.type === TimeSheetActionCreator.TIMESHEET_ACTION.RESET_REJECTED_TIMESHEET_LIST_STATE
        ) {
          return { ...state, ...defaultRejectedTimesheetsListState() };
        }
      
        if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_REJECTED_TIMESHEET_LIST) {
          return { ...state, loading: true, page: action.data.page, size: action.data.size, employeeName: action.data.employeeName || state?.employeeName || "", response: null, error: null, sortby: action.data.sortby || state?.sortby || null };
        }
      
        if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_REJECTED_TIMESHEET_LIST) {
          return { ...state, response: action.data, loading: false };
        }
      
        if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_REJECTED_TIMESHEET_LIST) {
          return { ...state, error: action.data, loading: false , response: null, page: 0, size: 10};
        }
      
        return state; 
      };
    

      export function defaultToBeInvoicedListState() {
        return {
          loading: false,
          response: null,
          error: null,
          page:0,
          size:10,
          employeeName: "",
          sortby: null
        };
      }
        export const ToBeInvoicedListReducer = (state, action) => { 
          if (
            !state ||
            action.type === TimeSheetActionCreator.TIMESHEET_ACTION.RESET_TOBEINVOICED_TIMESHEET_LIST_STATE
          ) {
            return { ...state, ...defaultToBeInvoicedListState() };
          }
        
          if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_TOBEINVOICED_TIMESHEET_LIST) {
            return { 
              ...state, 
              loading: true, 
              page: action.data.page, 
              size: action.data.size,
              employeeName: action.data.employeeName || state?.employeeName || "",
              sortby: action.data.sortby || state?.sortby || null,
              response: null,
              error: null
            };
          }
        
          if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_TOBEINVOICED_TIMESHEET_LIST) {
            return { ...state, response: action.data, loading: false };
          }
        
          if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_TOBEINVOICED_TIMESHEET_LIST) {
            return { ...state, error: action.data, loading: false , response: null, page: 0, size: 10};
          }
        
          return state; 
        };
      
  
export function defaultDownloadFileById() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}
export const DownloadFileByIdReducer = (state, action) => {
  if (
    !state ||
    action.type === TimeSheetActionCreator.TIMESHEET_ACTION.RESET_DOWNLOAD_FILE_BY_ID
  ) {
    return { ...state, ...defaultDownloadFileById() };
  }
 
  if (
    action.type === TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_DOWNLOAD_FILE_BY_ID
  ) {
    return { ...state, loading: true };
  }
  
  if (
    action.type === TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_DOWNLOAD_FILE_BY_ID
  ) {
    return { ...state, response: action.data, loading: false };
  }
  
  if (
    action.type === TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_DOWNLOAD_FILE_BY_ID
  ) {
    return { ...state, error: action.data, loading: false };
  }
  
  return state;
};

// Selected timesheets reducer
export function defaultSelectedTimesheetsState() {
  return {
    selectedTimesheets: [],
    selectedProject: null,
    selectedUser: null,
  };
}

export const SelectedTimesheetsReducer = (state = defaultSelectedTimesheetsState(), action) => {
  if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.CLEAR_SELECTED_TIMESHEETS) {
    return { ...state, ...defaultSelectedTimesheetsState() };
  }

  if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.SET_SELECTED_TIMESHEETS) {
    return { ...state, selectedTimesheets: action.data };
  }

  if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.ADD_SELECTED_TIMESHEET) {
    const existingIndex = state.selectedTimesheets.findIndex(
      timesheet => timesheet.id === action.data.id
    );
    if (existingIndex === -1) {
      return {
        ...state,
        selectedTimesheets: [...state.selectedTimesheets, action.data]
      };
    }
    return state;
  }

  if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.REMOVE_SELECTED_TIMESHEET) {
    return {
      ...state,
      selectedTimesheets: state.selectedTimesheets.filter(
        timesheet => timesheet.id !== action.data
      )
    };
  }

  if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.SET_SELECTION_CONSTRAINTS) {
    return {
      ...state,
      selectedProject: action.data.project,
      selectedUser: action.data.user
    };
  }

  return state;
};

export function defaultToBeInvoicedTimesheetListByEmployeeAndProjectState() {
  return {
    loading: false,
    response: null,
    error: null,
    eId: "",
    pId: "",
    sortby: null
  };
}
export const ToBeInvoicedTimesheetListByEmployeeAndProjectReducer = (state, action) => {
  if (
    !state ||
    action.type === TimeSheetActionCreator.TIMESHEET_ACTION.RESET_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT_STATE
  ) {
    return { ...state, ...defaultToBeInvoicedTimesheetListByEmployeeAndProjectState() };
  }
  if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.REQUEST_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT) {
    return { ...state, loading: true, eId: action.data.eId, pId: action.data.pId, sortby: action.data.sortby || state?.sortby || null };
  }
  if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.RESPONSE_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT) {
    return { ...state, response: action.data, loading: false };
  }
  if (action.type === TimeSheetActionCreator.TIMESHEET_ACTION.ERROR_TOBEINVOICED_TIMESHEET_LIST_BY_EMPLOYEE_AND_PROJECT) {
    return { ...state, error: action.data, loading: false, response: []};
  }
  return state;
};